import ai from './ai.png';
import { ReactComponent as AiComponent } from './ai.svg';
import avi from './avi.png';
import css from './css.png';
import csv from './csv.png';
import html from './html.png';
import javascript from './javascript.png';
import jpg from './jpg.png';
import { ReactComponent as JpgComponent } from './jpg.svg';
import json from './json.png';
import mp3 from './mp3.png';
import mp4 from './mp4.png';
import pdf from './pdf.png';
import { ReactComponent as PdfComponent } from './pdf.svg';
import png from './png.png';
import { ReactComponent as PngComponent } from './png.svg';
import ppt from './ppt.png';
import psd from './psd.png';
import { ReactComponent as PsdComponent } from './psd.svg';
import { ReactComponent as SvgComponent } from './svg.svg';
import txt from './txt.png';
import { ReactComponent as TxtComponent } from './txt.svg';
import xls from './xls.png';
import { ReactComponent as XlsComponent } from './xls.svg';
import xml from './xml.png';
import { ReactComponent as XmlComponent } from './xml.svg';
import zip from './zip.png';
import { ReactComponent as ZipComponent } from './zip.svg';

const components = {
    ai: AiComponent,
    jpg: JpgComponent,
    pdf: PdfComponent,
    png: PngComponent,
    psd: PsdComponent,
    svg: SvgComponent,
    txt: TxtComponent,
    xls: XlsComponent,
    xml: XmlComponent,
    zip: ZipComponent,
};

const images = {
    ai,
    avi,
    css,
    csv,
    html,
    javascript,
    jpg,
    json,
    mp3,
    mp4,
    pdf,
    png,
    ppt,
    psd,
    txt,
    xls,
    xml,
    zip,
};

const icons = {
    ai: {
        image: ai,
        component: AiComponent,
    },

    avi: {
        image: avi,
        component: null,
    },

    css: {
        image: css,
        component: null,
    },

    csv: {
        image: csv,
        component: null,
    },

    html: {
        image: html,
        component: null,
    },

    javascript: {
        image: javascript,
        component: null,
    },

    jpg: {
        image: jpg,
        component: components.jpg,
    },

    json: {
        image: json,
        component: null,
    },

    mp3: {
        image: mp3,
        component: null,
    },

    mp4: {
        image: mp4,
        component: null,
    },

    pdf: {
        image: pdf,
        component: components.pdf,
    },

    png: {
        image: png,
        component: components.png,
    },

    ppt: {
        image: ppt,
        component: null,
    },

    psd: {
        image: psd,
        component: components.psd,
    },

    txt: {
        image: txt,
        component: components.txt,
    },

    xls: {
        image: xls,
        component: components.xls,
    },

    xml: {
        image: xml,
        component: components.xml,
    },

    zip: {
        image: zip,
        component: components.zip,
    },
};

export const FileIcons = {
    components,
    images,
    icons,
    ...icons,

    // custom aliases
    default: icons.txt,
    jpeg: icons.jpg,
    js: icons.javascript,

    'text/css': icons.css,
    'text/csv': icons.csv,
    'text/html': icons.html,
    'text/javascript': icons.javascript,

    'application/javascript': icons.javascript,
    'application/pdf': icons.pdf,

    'image/png': icons.png,
    'image/jpg': icons.jpg,
    'image/jpeg': icons.jpg,

    'video/mp4': icons.mp4,
    'video/avi': icons.avi,

    'image/vnd.adobe.photoshop': icons.psd,

    getExtension(file) {
        file = file.split('.');

        if (file.length < 2) {
            return 'txt';
        }

        return file[file.length - 1];
    },

    getIcon(
        file?:
            | string
            | Partial<
                  File & {
                      mime_type: string;
                      type: string;
                      extension: string;
                      filename: string;
                      file_name: string;
                  }
              >,
    ) {
        if (!file) {
            return this.default;
        }

        // noinspection SuspiciousTypeOfGuard
        if (typeof file === 'string') {
            return (
                this[file] || // Treat as mime_type or extension
                this[this.getExtension(file)] || // Treat as extension of file
                this.default
            ); // Return default icon if no match
        }

        if (file.mime_type) {
            return this.getIcon(file.mime_type);
        }

        if (file.type) {
            return this.getIcon(file.type);
        }

        if (file.extension) {
            return this.getIcon(file.extension);
        }

        if (file.name) {
            return this.getIcon(file.name);
        }

        if (file.filename || file.file_name) {
            return this.getIcon(file.filename || file.file_name);
        }

        return this.default;
    },
};

export default FileIcons;
